import { styled } from '@mui/material/styles';
import {
  AppBar,
  Toolbar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { container, defaultFont, whiteColor, blackColor, primaryColor, defaultBoxShadow, infoColor, successColor, warningColor, dangerColor, boxShadow, drawerWidth, transition } from 'assets/styles/jss/main';

export const StyledAppBar = styled(AppBar)(({ ownerState }) => ({
  backgroundColor: 'transparent',
  boxShadow: 'none',
  borderBottom: '0',
  marginBottom: '0',
  position: 'absolute',
  width: '100%',
  paddingTop: '10px',
  zIndex: '5',
  color: '#555555',
  border: '0',
  borderRadius: '3px',
  padding: '5px 0',
  transition: 'all 150ms ease 0s',
  minHeight: '50px',
  display: 'block',
  ...(ownerState?.color === 'primary' && { backgroundColor: primaryColor, color: whiteColor }),
  ...(ownerState?.color === 'info' && { backgroundColor: infoColor, color: whiteColor }),
  ...(ownerState?.color === 'success' && { backgroundColor: successColor, color: whiteColor }),
  ...(ownerState?.color === 'warning' && { backgroundColor: warningColor, color: '#FFFFFF' }),
  ...(ownerState?.color === 'danger' && { backgroundColor: dangerColor, color: '#FFFFFF' }),
  ...(ownerState?.color === 'whiteColor' && { backgroundColor: whiteColor, color: blackColor }),
  ...(ownerState?.color === 'blackColor' && { backgroundColor: blackColor, color: whiteColor, ...defaultBoxShadow }),
}));

export const StyledToolbar = styled(Toolbar)({
  ...container,
  minHeight: 60,
  height: 60,
  paddingLeft: 0,
  paddingRight: 0,
});

export const LogoWrapper = styled('div')({
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  '@media screen and (max-width: 959.95px)': {
    maxWidth: '100%',
    justifyContent: 'center',
  },
  '@media screen and (min-width: 960px)': {
    width: 'fit-content',
    paddingLeft: 5,
    justifyContent: 'flex-start',
  },
});

export const Logo = styled('img')({
  marginLeft: '9vw',
  height: '60px',
});

export const StyledList = styled(List)({
  ...defaultFont,
  display: 'flex',
  '& li': { width: 'fit-content' },
  '@media screen and (max-width: 959.95px)': {
    display: 'none',
  },
});

export const StyledListMobile = styled(List)({
  ...defaultFont,
  fontSize: '14px',
  margin: 0,
  marginRight: '-15px',
  paddingLeft: '0',
  listStyle: 'none',
  color: `${blackColor} !important`,
  paddingTop: '0',
  paddingBottom: '0',
});

export const StyledListItem = styled(ListItem)({
  width: 'fit-content',
  paddingTop: 8,
  paddingBottom: 8,
  '&.MuiListItem-gutters': {
    paddingLeft: 16,
    paddingRight: 16,
  },
});

export const StyledListItemIcon = styled(ListItemIcon)({
  color: 'inherit',
  minWidth: 'auto',
  marginRight: '5px',
});

export const StyledListItemText = styled(ListItemText)({
  display: 'inline-block',
  fontSize: '14px',
});

export const NavLinkStyled = styled('a')(({ active }) => ({
  color: active ? primaryColor : blackColor,
  fontWeight: '500',
  textTransform: 'uppercase',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover, &:focus': {
    color: primaryColor,
  },
}));

export const DrawerPaper = {
  backgroundColor: whiteColor,
  border: 'none',
  bottom: '0',
  transitionProperty: 'top, bottom, width',
  transitionDuration: '.2s, .2s, .35s',
  transitionTimingFunction: 'linear, linear, ease',
  ...boxShadow,
  width: drawerWidth,
  position: 'fixed',
  display: 'block',
  top: '0',
  height: '100vh',
  visibility: 'visible',
  overflowY: 'visible',
  borderTop: 'none',
  textAlign: 'left',
  padding: '0',
  ...transition,
};

export const BurgerMenu = styled('div')({
  position: 'absolute',
  top: 10,
  left: 8,
  display: 'none',
  textAlign: 'center',
  color: blackColor,
  margin: 0,
  cursor: 'pointer',
  '& svg': { width: 24, height: 24 },
  '& span': { color: blackColor, fontSize: 12, lineHeight: 0.123 },
  '@media screen and (max-width: 960px)': {
    display: 'block',
  },
});

export const NeedHelp = styled('div')({
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  cursor: 'pointer',
  '& .text': { display: 'block' },
  '& .icon': { display: 'none' },
  '@media screen and (max-width: 1269px)': {
    '& .text': { display: 'none' },
    '& .icon': { display: 'block' },
  },
});